<template>
  <!-- eslint-disable max-len -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
    <path :fill="color" d="M15 7H9V1H7v6H1v2h6v6h2V9h6z" @click="$emit('click')"/>
  </svg>
</template>
<script>
export default {
  name: 'Plus',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
